import { useState, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { FormGroup, Input, Label, Button } from "reactstrap";

import { translations } from "./../../i18/translations.js";
import JuniorDataForm from "./../admin/JuniorDataForm.js";
import ConfirmDialog from './../../util/ConfirmDialog.js';

const JuniorMyData = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const [userData, setUserData] = useState(null);
    const {lang, user, setUser, showAlert, checkAccess, fetchLoggedUser} = useOutletContext();

    const [confirmOpen, setConfirmOpen] = useState(false);

    useEffect(() => {
        fetchJunior(user ? user.id : -1);
    }, [user]);

    const toggleConfirmDialog = () => setConfirmOpen(!confirmOpen);

    const saveMyProfile = async() => {
        if (!userData.fullname) {
            showAlert({type: "alert-danger", message: "error_validation_fullname"});
        } else if (userData.changePwd && (!userData.pwd || userData.pwd.length < 5)) {
            showAlert({type: "alert-danger", message: "error_validation_pwd_length"});
        } else if (userData.changePwd && (!userData.pwdRe || userData.pwd !== userData.pwdRe)) {
            showAlert({type: 'alert-danger', message: 'forgot_pwd_err_mismatch'});
        } else if (!userData.email) {
            showAlert({type: "alert-danger", message: "error_validation_email"});
        } else if (!userData.institute) {
            showAlert({type: "alert-danger", message: "error_validation_institute"});
        } else {
            save();
        }
    };

    const save = async () => {
        try {
            const payload = {
                junior: userData
            };
            const response = await fetch(`${API_URL}/admin/save_junior_my_data.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchLoggedUser();
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    const deleteMyProfile = async() => {
        try {
            const payload = {
                juniorId: userData.id
            };
            const response = await fetch(`${API_URL}/admin/delete_junior_registration.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchLoggedUser();
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    const fetchJunior = async (juniorId) => {
        try {
            const payload = {
                juniorId: juniorId
            };

            const response = await fetch(`${API_URL}/admin/get_junior_data.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setUserData(data);
            }
        } catch (error) {
            console.error("Error fetching my junior data:", error);
        }
    };

    return (
            <>
            <h1 className="mbkegy-content">{translations[lang].junior_mydata}</h1>
            
            <JuniorDataForm junior={userData} onChange={setUserData}/>            
            
            {userData && <div className="d-flex justify-content-between">
                <Button color="primary" onClick={saveMyProfile}>
                    {translations[lang].save}
                </Button>
                <Button color="danger" onClick={toggleConfirmDialog}>
                    {translations[lang].junior_delete_myprofile}
                </Button>
            </div>}
            
            <ConfirmDialog 
                title={translations[lang].junior_delete_myprofile}
                yes={translations[lang].yes}
                no={translations[lang].cancel}
                isOpen={confirmOpen} 
                toggle={toggleConfirmDialog} 
                onConfirm={deleteMyProfile} 
                message={translations[lang].junior_delete_myprofile_confirm}
                />            
            </>
            );
};

export default JuniorMyData;